import { useRef, useCallback } from 'react'; // A workaround for a React bug when `useInsertionEffect()` doesn't run twice on mount
// in "strict" mode unlike `useEffect()` and `useLayoutEffect()` do.
// https://github.com/facebook/react/issues/26320

export default function useEffectDontMountTwiceInStrictMode(useEffect, handler, dependencies) {
  if (!Array.isArray(dependencies)) {
    throw new Error('Dependencies argument must be an array');
  }

  var _useEffectStatus = useEffectStatus(),
      onEffect = _useEffectStatus.onEffect;

  var _usePrevousValue = usePrevousValue(dependencies),
      onChange = _usePrevousValue.onChange;

  useEffect(function () {
    var _onEffect = onEffect(),
        isInitialRun = _onEffect.isInitialRun;

    var previousDependencies = onChange(dependencies);

    if (isInitialRun || !isShallowEqualArrays(previousDependencies, dependencies)) {
      var cleanUpFunction = handler();

      if (typeof cleanUpFunction === 'function') {
        throw new Error('An effect can\'t return a clean-up function when used with `useEffectDontMountTwiceInStrictMode()` because the clean-up function won\'t behave correctly in that case');
      }
    }
  }, dependencies);
}

function useEffectStatus() {
  var hasMounted = useRef(false);
  var onEffect = useCallback(function () {
    var wasAlreadyMounted = hasMounted.current;
    hasMounted.current = true;
    return {
      isInitialRun: !wasAlreadyMounted
    };
  }, []);
  return {
    onEffect: onEffect
  };
}

function usePrevousValue(value) {
  var prevValue = useRef(value);
  var onChange = useCallback(function (value) {
    var previousValue = prevValue.current;
    prevValue.current = value;
    return previousValue;
  }, []);
  return {
    onChange: onChange
  };
}

function isShallowEqualArrays(a, b) {
  if (a.length !== b.length) {
    return false;
  }

  var i = 0;

  while (i < a.length) {
    if (a[i] !== b[i]) {
      return false;
    }

    i++;
  }

  return true;
}
//# sourceMappingURL=useEffectDontMountTwiceInStrictMode.js.map